var _rect, _rect2, _rect3, _rect4, _rect5, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 60,
    viewBox: "0 0 91 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 90,
    height: 60,
    rx: 2,
    fill: "white",
    fillOpacity: 0.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 7.34766,
    width: 81.3158,
    height: 41.0526,
    rx: 1.57895,
    fill: "#616161"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.23633,
    y: 42.084,
    width: 19.7368,
    height: 11.8421,
    rx: 1.57895,
    fill: "#858585"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5527,
    y: 42.084,
    width: 19.7368,
    height: 11.8421,
    rx: 1.57895,
    fill: "#858585"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 51.8691,
    y: 42.084,
    width: 19.7368,
    height: 11.8421,
    rx: 1.57895,
    fill: "#858585"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.1855 43.6629C73.1855 42.7909 73.8925 42.084 74.7645 42.084H82.6592V53.9261H74.7645C73.8925 53.9261 73.1855 53.2192 73.1855 52.3471V43.6629Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid03);
export default __webpack_public_path__ + "static/media/grid_03.bbc6707ce5a68d1164c2b43bdf77163e.svg";
export { ForwardRef as ReactComponent };